import $axios from '@/helpers/axios-instance';

const baseUrl = process.env.API_ADMIN_URL;

export default {
  getTeachers(schoolCode) {
    return $axios.get(`api/Schools/GetTeachersForSchool/${schoolCode}`, {
      baseURL: baseUrl,
    });
  },
  newTeacher(teacher) {
    return $axios.post('api/Schools/NewTeacher', teacher, { baseURL: baseUrl });
  },
  newGuest(guest) {
    return $axios.post('api/Schools/NewGuest', guest, { baseURL: baseUrl });
  },
  removeTeacher(id) {
    return $axios.delete(`api/Schools/RemoveTeacher/${id}`, {
      baseURL: baseUrl,
    });
  },
  updateSchoolCode(schoolCode) {
    return $axios.put('api/Schools/UpdateSchoolCode', schoolCode, {
      baseURL: baseUrl,
    });
  },
  getSchoolCode() {
    return $axios.get('api/Schools/GetSchoolCode', {
      baseURL: baseUrl,
    });
  },
};



// WEBPACK FOOTER //
// ./src/api/admin.js